























import { Component, Vue } from "vue-property-decorator";
import Modal from "@/shared/components/modal.vue";
import { ConsultoresService } from "@/services/consultores.service";
import Confirm from "@/shared/components/confirm.vue";

@Component({
  components: {
    Modal,
    Confirm,
  },
})
export default class AdicionarMotivoInatividade extends Vue {
  idConsultor!: number;
  loading = false;
  motivoInatividade = "";
  tituloManter = "Motivo da inatividade";

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async adicionarMotivo(idConsultor: number) {
    this.motivoInatividade = "";
    this.idConsultor = idConsultor;
    const modal = this.$refs.modal as Modal;
    const p = modal.open();
    return p;
  }

  async adicionarMotivoInatividade() {
    const modal = this.$refs.modal as Modal;
    let res = true;
    if (!this.motivoInatividade) {
      const modalConfirm = this.$refs.confirm as Confirm;
      const title = "Alerta de campo vazio";
      const text = "Deseja realmente deixar o campo motivo em vazio?";
      res = await modalConfirm.open(title, text);
    }
    if (res) {
      this.loading = true;
      try {
        await ConsultoresService.AtivarInativar(
          this.idConsultor,
          this.motivoInatividade
        );
        this.loading = false;
      } finally {
        this.loading = false;
      }
      return modal.close(true);
    }
  }
}
